import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { defaultNS, resources } from './resources';

/**
 * Pin the dashboard to `en-IN`. No browser detection — if we ever add more
 * locales, the decision surfaces will be deliberate (e.g. per-tenant setting,
 * not the browser header). See PRD.md §A2 and .cursor/rules/i18n-money-date.mdc.
 */
export const APP_LOCALE = 'en-IN' as const;

void i18n.use(initReactI18next).init({
  resources,
  lng: APP_LOCALE,
  fallbackLng: APP_LOCALE,
  defaultNS,
  ns: Object.keys(resources[APP_LOCALE]),
  interpolation: {
    escapeValue: false, // React handles XSS escaping.
  },
  returnNull: false,
  returnEmptyString: false,
});

export default i18n;
